import { FolderPreviewManagement, FolderPreviewManagementProps } from '@common/components/folder-preview-management';
import * as React from 'react';
import { CustomPanelProps } from './custom-panel.types';
import { useController } from './custom-panel.controller';
import { I18n } from 'react-redux-i18n';
import { TestDetailsWnd } from '../TestDetailsWnd';
import { MessageBox } from '@common/components/MessageBox';
import FormatManagement, { FORMAT_MANAGEMENT_MODE } from '@common/components/FormatManagement';

import './custom-panel.styles.scss';

export const CustomPanel: React.FC<CustomPanelProps> = (props) => {
  const { close, createFolder, deletePanelFolder, getPanels, deletePanel, mode } = props;
  
  const {
    testDetailsHasErrors,
    handleChooseCustomPanelForSaveAs,
    handleFolderCreate,
    handleFolderDelete,
    handlePanelDelete,
    getAndSetFolders,
    getAndSetFormats,
    resetFormats,
    folders,
    formats,
    handleSaveAsClick,
    saveAsFormatManagementOpened,
    closeSaveAsFormatManagement,
    getProcessedFolders,
    handleTestSubmit,
    labName,
    otherLabName,
    handleLabChange,
    handleOtherLabChange,
    labs,
    closeMessage,
    messageProps,
    renderCustomTestName,
    closeTestDetails,
    testDetailsOpened,
    currentConfig,
    handleFolderPreviewSubmit,
    submitting,
  } = useController(props);

  return (
    <>
      <MessageBox
        hideMessageBox={closeMessage}
        {...messageProps}
      />
      {currentConfig && (
        <FolderPreviewManagement 
          mode={mode}
          submitOnSelect={mode === 'edit'}
          deleteFormat={(folderId, formatId) => deletePanel(formatId)}
          previewProps={{
            title: currentConfig.preview.title,
            submitBtnProps: {
              text: currentConfig.preview.submitBtnProps?.title
            },
            showNameField: mode === 'create'
          }}
          formatLoaderProps={{
            title: currentConfig?.formatManagement.title,
            deleteFormatBtnProps: {
              text: I18n.t('Delete Panel')
            },
            submitBtnProps: currentConfig.formatManagement.submitBtnProps,
          }}
          close={close}
          getFormats={getPanels}
          createFolder={createFolder}
          deleteFolder={deletePanelFolder}
          getFolders={getProcessedFolders}
          onSubmit={handleFolderPreviewSubmit as FolderPreviewManagementProps['onSubmit']}
        />
      )}
      {testDetailsOpened && (
        <TestDetailsWnd 
          show
          title={I18n.t('Custom Panel Details')}
          withSaveAsBtn
          fields={[
            'lab',
            'otherLab'
          ]}
          renderAdditionalFieldBefore={renderCustomTestName}
          onHide={closeTestDetails}
          test={{
            lab: labName,
            otherLab: otherLabName,
            genes: []
          }}
          saving={submitting}
          labs={labs.map((x) => x.name)}
          errors={{}}
          hasErrors={testDetailsHasErrors}
          saveFieldValue={handleOtherLabChange}
          onLabSelected={handleLabChange}
          onSaveAs={handleSaveAsClick}
          onSave={handleTestSubmit}
        />
      )}
      {saveAsFormatManagementOpened && (
        <FormatManagement 
          title={I18n.t('Save As Custom Panel')}
          deleteFormatBtnProps={{
            text: I18n.t('Delete Panel')
          }}
          close={closeSaveAsFormatManagement}
          folders={folders}
          formats={formats}
          mode={FORMAT_MANAGEMENT_MODE.save}
          isAllowedToSubmit={(params: { folderId: number; formatId: number; newFormatName?: string }) =>
            Boolean(params.folderId) && (Boolean(params.formatId) || Boolean(params.newFormatName))
          }
          getFormats={getAndSetFormats}
          resetFormats={resetFormats}
          getFolders={getAndSetFolders}
          onSubmit={handleChooseCustomPanelForSaveAs}
          onFormatDelete={handlePanelDelete}
          onFolderDelete={handleFolderDelete}
          onFolderCreate={handleFolderCreate}
        />
      )}
    </>
  );
};